import { useTranslation } from 'react-i18next';
import { usePermissionMatrix } from '@/hooks/usePermissionMatrix';
import { permissionLabel } from '@/services/errorMessage';
import type { Permission } from '@/api/endpoints/permissions';

/**
 * QA-W7-2: the reason a write action is off, or '' when it is allowed.
 *
 * Wraps usePermissionMatrix().can(): while permissions_v2 is off, or until
 * GET /api/permissions/me answers, everything is allowed (nothing on screen
 * changes). When the organisation removed the permission from the role, the
 * action is disabled and the reason names the permission by its matrix label.
 */
export function usePermissionGuard(): (permission: Permission) => string {
  const { can } = usePermissionMatrix();
  const { t } = useTranslation(['common', 'admin']);
  return (permission) => (can(permission) ? '' : t('common:permissionGuard.revoked', { permission: permissionLabel(t, permission) }));
}
